import React from 'react';
import PropTypes from 'prop-types';
import InputSaveButton from './InputSaveButton';
import {Input} from 'antd';

InputSave.propTypes = {
  maxLength: PropTypes.number,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  disabled: PropTypes.func,
  prefix: PropTypes.node,
};

function InputSave(props) {
  const [value, setValue] = React.useState('');

  return <div className="space space-center-y relative">
    <Input
      prefix={props.prefix || null}
      maxLength={props.maxLength}
      value={value}
      placeholder={props.value || props.placeholder || "Type assistant name"}
      size={props.size || "large"}
      bordered={false}
      className={`input-bold`}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      onChange={(e) => {
        const name = e.target.value.trim();
        setValue(name);
        props.onChange?.(name);
      }}
    />
    <InputSaveButton
      onClick={props.onSave}
      show={!!value}
      disabled={props.disabled(value)}
    />
  </div>
}

export default InputSave;
